export var CouponScopeGroup;
(function (CouponScopeGroup) {
    CouponScopeGroup["Product"] = "product";
    CouponScopeGroup["Collection"] = "collection";
    CouponScopeGroup["Service"] = "service";
    CouponScopeGroup["Ticket"] = "ticket";
    CouponScopeGroup["Event"] = "event";
    CouponScopeGroup["Plan"] = "plan";
    CouponScopeGroup["Menu"] = "menu";
    CouponScopeGroup["MenuItem"] = "menuItem";
    CouponScopeGroup["MenuSection"] = "menuSection";
})(CouponScopeGroup || (CouponScopeGroup = {}));
//# sourceMappingURL=group.js.map